<template>
    <div class="r0901">
        <b-table
            :data="branch.products"
            :hoverable="true">

            <template slot-scope="props">
                <b-table-column label="Pakke ID">
                    {{ props.row.id }}
                </b-table-column>

                <b-table-column label="Opphav">
                    {{ findReportset(props.row.instanceId) }}
                </b-table-column>

                <b-table-column label="Navn">
                    {{ props.row.name }}
                </b-table-column>

                <b-table-column label="Rapporttype">
                    {{ reportTypes[props.row.reportType].name }}
                </b-table-column>
                
                <b-table-column numeric>
                    <b-tooltip label="Rediger produktnavn">
                        <a class="button is-primary" @click="editProduct(props.row)">
                            <b-icon pack="fa" icon="edit"></b-icon>
                        </a>
                    </b-tooltip> 

                    <b-tooltip type="is-danger" label="Slett produkt" style="margin-left: 8px">
                        <a class="button is-danger" @click="confirmDeleteProduct(props.row)">
                            <b-icon pack="fa" icon="trash"></b-icon>
                        </a> 
                    </b-tooltip>
                </b-table-column>

            </template>

            <template slot="empty">
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p>
                            <b-icon
                                pack="fa"
                                icon="recycle"
                                size="is-large">
                            </b-icon>
                        </p>
                        <p>Ingenting her, legg til nytt produkt med knappen nedenfor.</p>
                    </div>
                </section>
            </template>

        </b-table>

        <a class="button is-primary" style="margin-top: 16px" @click="newProduct()">
            <b-icon pack="fa" icon="plus"></b-icon>
            <span>Nytt produkt</span>
        </a>

    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ProductModal from '@/components/products/ProductModal.vue'

export default {
    props: ['branch', 'reportTypes'],
    computed: mapGetters('reportsets', ['sets']),
    methods: {
        ...mapActions('products', ['deleteProduct']),
        editProduct (product) {
            this.launchModal({...product, ...{branchName: this.branch.name}})
        },
        newProduct () {
            const product = {
                branchId: this.branch.id,
                branchName: this.branch.name,
                name: '',
                id: undefined
            }

            this.launchModal(product)
        },
        launchModal (product) {
            this.$buefy.modal.open({
                parent: this,
                component: ProductModal,
                hasModalCard: true,
                props: {product: product, isNewProduct: product.id === undefined}, 
            }) 
        },
        
        confirmDeleteProduct (product) {
            this.$buefy.dialog.confirm({
                title: 'Slette gavekortprodukt',
                message: 'Er du sikker på at du ønsker å <b>slette</b> valgt gavekortprodukt?',
                confirmText: 'Slett',
                cancelText: 'Avbryt',
                type: 'is-danger',
                hasIcon: true,
                onConfirm: () => this.deleteConfirmAction(product)
            })
        },
        async deleteConfirmAction (product) {
            try {
                await this.deleteProduct(product)
                this.$buefy.toast.open({
                    message: 'Gavekortprodukt ble slettet',
                    type: 'is-success',
                    position: 'is-bottom'
                })
            }
            catch (error) {
                this.$buefy.toast.open({
                    message: 'En feil oppstod under sletting av gavekortprodukt',
                    type: 'is-danger',
                    position: 'is-bottom'
                })
            }
        },
        findReportset (reportset) {
            let val = this.sets.find(i => i.id == reportset)
            if (val)
                return `${val.name} (${reportset})`
            
            return reportset
        }


    }
}
</script>
